const cascadeSubscribers = new Set()
const categoryChangeSubscribers = new Set()

export const subscribeToCascade = (callback) => {
  cascadeSubscribers.add(callback)

  return () => cascadeSubscribers.delete(callback)
}

export const publishCascade = (selection) => {
  cascadeSubscribers.forEach(callback => callback(selection))
}

export const subscribeToCategoryChange = (callback) => {
  categoryChangeSubscribers.add(callback)

  return () => categoryChangeSubscribers.delete(callback)
}

export const publishCategoryChange = () => {
  categoryChangeSubscribers.forEach(callback => callback())
}
